import classNames from 'classnames'
import { tv } from 'tailwind-variants'

import { ResponsiveImage } from '../ResponsiveImage'
import { Asset, AssetFields } from 'contentful'

const diameter = {
  XL: 100,
  L: 68,
  M: 52,
  S: 28,
}

export type AuthorSizes = 'XL' | 'L' | 'M' | 'S'

const authorCss = tv({
  base: 'rounded-[50%] mb-4 max-xl:mb-2 max-lg:mr-6 max-lg:mb-0',
  variants: {
    size: {
      XL: 'w-25 h-25 mr-3 max-md:w-20 max-md:h-20',
      L: 'max-md:w-12 max-md:h-12 mr-3 w-17 h-17',
      M: 'mr-2 w-13 h-13',
      S: 'mr-[6px] w-7 h-7',
    },
  },
  defaultVariants: {
    size: 'M',
  },
})

// TODO: change this after
type AuthorAvatarProps = {
  size?: AuthorSizes
  alt?: string
  width?: number
  height?: number
  quality?: number
  className?: string
  asset: Asset<'WITHOUT_UNRESOLVABLE_LINKS', string>
  [x: string]: unknown
}

export const AuthorAvatar = ({ className, size = 'M', ...props }: AuthorAvatarProps) => {
  return (
    <div className={classNames(authorCss({ size }), className)}>
      <ResponsiveImage
        {...props}
        asset={props.asset.fields as AssetFields}
        width={diameter[size]}
      />
    </div>
  )
}
